// Modularity
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, Outlet } from 'react-router-dom';
import loadable from '@loadable/component';

// Layouts
import Login from '../../pages/Auth/Login';
import HomePage from '../../pages/Home/Home';
import RootLayout from '../../layouts/RootLayout';
import ActivitiesLayout from '../../layouts/ActivitiesLayout';
import ErrorElenment from '../../layouts/Errorelement';
import MainAuthForm from '../../pages/Auth/MainAuthForm';

// Components
// const HomePage = loadable(()=> import('../../pages/Home/Home'));
const Rounds = loadable(() => import('../../pages/Rounds/Rounds'));
const KnouckOuts = loadable(() => import('../../pages/knockouts/Knockouts'));

const League = loadable(() => import('../../pages/League/League'));
const Calender = loadable(() => import('../../pages/Calender/Calender'));
const Teams = loadable(() => import('../../pages/Teams/Teams'));
const Activities = loadable(() => import('../../pages/Rounds/ActivitiesList/Activities'));
// const MainAuthForm = loadable(()=> import('../../pages/Auth/MainAuthForm'));
const UserProfile = loadable(() => import('../../pages/UserProfile/UserProfile'));

const HelpCenter = loadable(() => import('../../pages/HelpCenter/HelpCenter'));
const TeamProfile = loadable(() => import('../../pages/Teams/TeamProfile/TeamProfile'));
const MyActivity = loadable(() => import('../../pages/MyActivity/MyActivity'));
const Tournament = loadable(() => import('../../pages/Tournament/Tournament'));
const Notifications = loadable(() => import('../../pages/Notifications/Notifications'));
const ChangePassword = loadable(() => import('../../pages/Auth/ChangePassword'));
const ForgetPassword = loadable(() => import('../../pages/Auth/ForgetPassword'));

const userAuthed = () => {
	if (!localStorage.getItem('userToken')) {
		throw new Error('You are not Authenticated, Try to Login Again');
	} else {
		return new Promise((resolve, reject) => {
			resolve('some string');
		});
	}
};

const router = createBrowserRouter(
	createRoutesFromElements([
		<>
			{/* login routes */}
			<Route path="" element={<MainAuthForm />} id="login">
				<Route path="login" element={<Login />} />
				<Route path="reset-password" element={<ChangePassword />} />
				<Route path="forget-password" element={<ForgetPassword />} />
			</Route>

			{/* Main project routes */}
			<Route
				path=""
				element={<RootLayout />}
				id="page_content"
				loader={userAuthed}
				errorElement={localStorage.getItem('userToken') ? <ErrorElenment /> : <Navigate to="login" />}
			>
				<Route index element={<HomePage />} id="home" />
				<Route path="rounds" element={<ActivitiesLayout />}>
					<Route index element={<Rounds />} />
					<Route path="activities/:slug?/:type?" element={<Activities />} />
					<Route path="my-activity/:type/:slug" element={<MyActivity />} />
				</Route>

				<Route path="tournament" element={<Tournament />} />
				<Route path="championscup" element={<KnouckOuts />} />
				<Route path="league" element={<League />} />
				<Route path="calender" element={<Calender />} />
				<Route path="teams" element={<ActivitiesLayout />}>
					<Route index element={<Teams />} />
					<Route path="team-profile" element={<TeamProfile />} />
				</Route>

				{/* routes of user drop down menu */}
				<Route
					path="my-profile"
					element={<UserProfile />}
					// loader={getUserData}
				/>
				<Route
					path="helpCenter"
					element={<HelpCenter />}
					// loader={getFaqs}
					// id="faqs"
					errorElement={<ErrorElenment />}
				/>

				{/* routes of notifications drop down menu */}
				<Route path="notifications" element={<Notifications />} />

				<Route path="*" element={<Navigate to="/" />} />
			</Route>
		</>,
	]),
);

export default router;
